var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fc-user-avatar",style:(_vm.avatarStyle),attrs:{"aria-hidden":_vm.ariaHidden,"aria-label":_vm.ariaLabel,"role":_vm.ariaLabel ? 'img' : undefined,"data-testid":_vm.dataTestId}},[_c('span',{staticClass:"fc-user-avatar__initial"},[_vm._v(_vm._s(_vm.displayInitial))])])
}
var staticRenderFns = []

export { render, staticRenderFns }